import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import Modalexpercommentbacktex from './Modalexpercommentbacktex';
import { URL,api } from '../../api';


export default class Commentexlistexforshow extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentex:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
        api.get('registercon/selectreportscorearticalexperlist/'+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentex: res.data})
        }) 

      }, 0);

  }

  list() {
      setTimeout(() => {
        api.get('registercon/selectreportscorearticalexperlist/'+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentex: res.data})
        }) 
      }, 0);
  }



    render() {
        

        return (
            <>
           <MDBTable small>
                <MDBTableHead color="blue-grey lighten-3" textWhite>
                    <tr>
                    <th>ลำดับ</th>
                    <th>ผู้ทรงคุณวุฒิ</th>
                    <th>คะแนน</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                                {this.state.commentex.map((commentex,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{commentex.name_expert}</td>
                                    <td>{commentex.scores === null?<>0 / 100</>:<>{commentex.scores} / 100</>} </td>
                                    </tr>
                                )}
                </MDBTableBody>
           </MDBTable>
           
            </>
          
        )
    }
}


